module.exports = __webpack_public_path__ + "static/media/check-off.8c92fa5a.svg";